// extracted by mini-css-extract-plugin
module.exports = {"logowrapper":"homelogo-module--logowrapper--hQON7","logo":"homelogo-module--logo--2Dy3r"};